// ./src/components/features/NeedAddVenue/NeedAddVenue.tsx
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { EmptyState } from "@/components/generic";

export interface NeedAddVenueProps {
  display?: boolean;
  descriptionExtra?: string;
}

export const NeedAddVenue: React.FC<NeedAddVenueProps> = ({
  display,
  descriptionExtra,
}) => {
  const navigate = useNavigate();

  const description = `You have no venues yet. Please add a venue. ${descriptionExtra}`;

  // Handle back to venues
  const handleGoToVenues = useCallback(() => {
    navigate("/venues");
  }, [navigate]);

  if (!display) {
    return null;
  }

  return (
    <EmptyState
      display={display}
      title="Add a venue"
      description={description}
      actionIcon="Building"
      actionLabel="Go to Venues"
      onAction={handleGoToVenues}
    />
  );
};
